module.exports = __webpack_public_path__ + "img/arrow-gray.33bb1b08.svg";